export default __webpack_public_path__ + "static/media/GSP7.f8c7ca7a.png";